import { Component } from "@angular/core";
import { MdDialog, MdDialogRef } from '@angular/material';
import { UserService } from "../../services/UserService";
import { Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import { PagerService } from "../../services/PagerService";
import { PageLayoutUserRightsSummaryComponent } from '../user-rights-summary/userrightssummary.component';
import { LicenseRoles, OTARoles } from "../../interfaces/LicenseModel";

@Component({
  selector: "my-page-layout-application",
  styles: [],
  template: require('./user.component.html'),
})
export class PageLayoutUserComponent {
  userData;
  errorMessage: string;
  pager: any = {};
  pagedItems: any[];
  userrightssummary: any;

  constructor(
    public dialog: MdDialog,
    private router: Router,
    private pagerService: PagerService,
    private userService: UserService,
    private adalService: AdalService
  ) {
    //Check Authentication
    if (!this.adalService.getCachedToken()) {
      this.router.navigate(["login"]);
    }
    this.getUserDetail();
  }

  getUserDetail() {
    this.userService.getUser().subscribe(
      (data) => {
        this.userData = data;
        this.userData.forEach((element) => {
          element.Role = this.setRoleText(element.Role,element.LicenseRole);
        });
        this.pagedItems = this.userData;
        //this.setPage(1);
      },
      (error) => {
        this.errorMessage = error;
      }
    );
  }

  setRoleText(OTARole: number,licenseRole:number): string {
    if(OTARole==0 && licenseRole!=0){
      return LicenseRoles[licenseRole];
    }
    else if(OTARole!=0 && licenseRole==0){
      return OTARoles[OTARole];
    }
    else if(OTARole!=0 && licenseRole!=0){
      return OTARoles[OTARole] + ' , ' +LicenseRoles[licenseRole];
    }
  }

  openDialogWithAResult(row) {
    
    let dialogRef: MdDialogRef<PageLayoutUserRightsSummaryComponent> = this.dialog.open(PageLayoutUserRightsSummaryComponent, { height: "50%", width: "60%", data: { userId: row.UserId, UserName: row.Name, Role: row.Role } });
    dialogRef.afterClosed().subscribe(_result => {
        // Do Nothing
    });
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.userData.length, page);
    this.pagedItems = this.userData.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-management/user/user.component.ts